/* No autoplay, tracking or external embeds. Native controls work without JS. */
(() => {
  if (window.kiwabiSoundBound) return;
  window.kiwabiSoundBound = true;
  document.addEventListener('play', (event) => {
    if (!(event.target instanceof HTMLMediaElement) || !event.target.matches('.ks-audio')) return;
    document.querySelectorAll('.ks-audio').forEach((player) => {
      if (player !== event.target && !player.paused) player.pause();
    });
  }, true);
})();
